import { render, staticRenderFns } from "./publicizeList.vue?vue&type=template&id=1553747b&scoped=true"
import script from "./publicizeList.vue?vue&type=script&lang=js"
export * from "./publicizeList.vue?vue&type=script&lang=js"
import style0 from "./publicizeList.vue?vue&type=style&index=0&id=1553747b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1553747b",
  null
  
)

export default component.exports